import { useCallback } from "react";
import { useAppSelector } from "redux/hooks";

function usePermission() {
  const userRoleInStore = useAppSelector((state) => state.common.userRoles);
  const userRoles =
    userRoleInStore.length > 0
      ? userRoleInStore
      : localStorage.getItem("roles");

  const isAdminHCNS = useCallback(() => {
    if (userRoles.includes("hcns")) return true;
    return false;
  }, [userRoles]);

  const isKetoan = () => {
    if (userRoles.includes("ke_toan") && !userRoles.includes("hcns"))
      return true;
    return false;
  };
  const isGiamDoc = () => {
    if (userRoles.includes("giam_doc") && !userRoles.includes("hcns"))
      return true;
    return false;
  };
  const isQuanLy = () => {
    if (userRoles.includes("quan_ly") && !userRoles.includes("hcns"))
      return true;
    return false;
  };
  const isNhanVien = () => {
    if (
      userRoles.includes("hcns") ||
      userRoles.includes("ke_toan") ||
      userRoles.includes("giam_doc") ||
      userRoles.includes("quan_ly")
    )
      return false;
    return true;
  };
  return { isAdminHCNS, isGiamDoc, isKetoan, isQuanLy, isNhanVien };
}

export default usePermission;
